// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-layout {
  display: flex;
  min-height: 100vh;
  background: #F1F5F9;
}

.admin-main {
  flex: 1 1;
  min-width: 0;
  margin-left: 240px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  transition: margin-left 0.22s ease, margin-right 0.22s ease;
}
@media (max-width: 1024px) {
  .admin-main {
    margin-left: 0 !important;
  }
}

html[dir=rtl] .admin-sidebar {
  right: 0;
  left: auto;
  border-right: none;
  border-left: 1px solid #1A2E4A;
}
html[dir=rtl] .admin-main {
  margin-left: 0;
  margin-right: 240px;
}
@media (max-width: 1024px) {
  html[dir=rtl] .admin-main {
    margin-right: 0 !important;
  }
}
html[dir=rtl] .admin-sidebar__link {
  border-left: none;
  border-right: 3px solid transparent;
}
html[dir=rtl] .admin-sidebar__link--active {
  border-right-color: #2563EB;
}

.admin-topbar {
  height: 60px;
  background: #FFFFFF;
  border-bottom: 1px solid #E2E8F0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  padding: 0 24px;
  gap: 16px;
  position: sticky;
  top: 0;
  z-index: 100;
}

.admin-topbar__menu-btn {
  display: none;
  background: transparent;
  border: none;
  color: #374151;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}
.admin-topbar__menu-btn:hover {
  background: #F3F4F6;
}
.admin-topbar__menu-btn:focus-visible {
  outline: 2px solid #2563EB;
  outline-offset: 2px;
}
@media (max-width: 1024px) {
  .admin-topbar__menu-btn {
    display: flex;
  }
}

.admin-topbar__page-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  flex: 1 1;
}

.admin-topbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.admin-topbar__icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #F3F4F6;
  border: none;
  color: #374151;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.15s, color 0.15s;
}
.admin-topbar__icon-btn:hover {
  background: #E5E7EB;
  color: #111827;
}
.admin-topbar__icon-btn:focus-visible {
  outline: 2px solid #2563EB;
  outline-offset: 2px;
}

.admin-topbar__avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1D4ED8, #2563EB);
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
}

.admin-content {
  flex: 1 1;
  padding: 28px 28px;
}
@media (max-width: 768px) {
  .admin-content {
    padding: 16px;
  }
}
.admin-content:focus {
  outline: none;
}

.admin-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 199;
  backdrop-filter: blur(2px);
}

.admin-sidebar {
  width: 240px;
  min-height: 100vh;
  background: #0B1527;
  border-right: 1px solid #1A2E4A;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 200;
  transition: width 0.22s ease, transform 0.22s ease;
  overflow: hidden;
}
@media (max-width: 1024px) {
  .admin-sidebar {
    transform: translateX(-100%);
    width: 240px !important;
  }
  .admin-sidebar--open {
    transform: translateX(0);
    box-shadow: 4px 0 32px rgba(0, 0, 0, 0.4);
  }
}

.admin-sidebar__logo {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 16px;
  height: 60px;
  border-bottom: 1px solid #1A2E4A;
  flex-shrink: 0;
}

.admin-sidebar__logo-icon {
  color: #2563EB;
  flex-shrink: 0;
}

.admin-sidebar__logo-text {
  font-size: 15px;
  font-weight: 700;
  color: #FFFFFF;
  letter-spacing: -0.02em;
  white-space: nowrap;
  flex: 1 1;
}

.admin-sidebar__nav {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 8px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.admin-sidebar__nav::-webkit-scrollbar {
  display: none;
}
.admin-sidebar__nav ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.admin-sidebar__link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border-radius: 8px;
  color: #94A3B8;
  font-size: 13.5px;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
  border-left: 2px solid transparent;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}
.admin-sidebar__link:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #CBD5E1;
}
.admin-sidebar__link--active {
  background: rgba(37, 99, 235, 0.18);
  color: #FFFFFF;
  border-left-color: #2563EB;
}
.admin-sidebar__link--active .admin-sidebar__link-icon {
  color: #2563EB;
}
.admin-sidebar__link:focus-visible {
  outline: 2px solid #2563EB;
  outline-offset: 2px;
}

.admin-sidebar__link-icon {
  flex-shrink: 0;
  color: #64748B;
}

.admin-sidebar__link-label {
  flex: 1 1;
}

.admin-sidebar__home {
  border-top: 1px solid #1A2E4A;
  padding: 8px 8px 0;
}

.admin-sidebar__footer {
  border-top: 1px solid #1A2E4A;
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.admin-sidebar__user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
}

.admin-sidebar__avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1D4ED8, #2563EB);
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.admin-sidebar__user-info {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.admin-sidebar__user-name {
  font-size: 13px;
  font-weight: 600;
  color: #FFFFFF;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.admin-sidebar__user-role {
  font-size: 11px;
  color: #94A3B8;
}

.admin-sidebar__logout {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #94A3B8;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}
.admin-sidebar__logout:hover {
  background: rgba(239, 68, 68, 0.12);
  color: #FCA5A5;
}
.admin-sidebar__logout:focus-visible {
  outline: 2px solid #EF4444;
  outline-offset: 2px;
}

/* Admin portal neumorphism: shared raised navigation and content surfaces. */
.admin-layout {
  background: radial-gradient(circle at 88% 0%, #f9fcff 0, transparent 31%), #e9eff6;
  color: #2c435d;
}

.admin-topbar {
  background: #edf3f8;
  border-bottom: 0;
  box-shadow: 0 7px 20px rgba(145, 163, 184, 0.16);
}

.admin-topbar__page-title {
  color: #1c3456;
  font-weight: 750;
}

.admin-topbar__menu-btn, .admin-topbar__icon-btn {
  color: #39516d;
  background: #edf3f8;
  border-radius: 10px;
  box-shadow: 4px 4px 9px rgba(145, 163, 184, 0.2), -3px -3px 7px rgba(255, 255, 255, 0.82);
}
.admin-topbar__menu-btn:hover, .admin-topbar__icon-btn:hover {
  color: #1c3456;
  background: #f4f8fb;
}

.admin-content {
  padding: 28px;
}

.admin-sidebar {
  background: linear-gradient(160deg, #1f385b 0%, #172944 100%);
  border-right: 0;
  box-shadow: 8px 0 22px rgba(43, 67, 93, 0.18);
}

.admin-sidebar__logo, .admin-sidebar__footer {
  border-color: rgba(201, 216, 232, 0.14);
}

.admin-sidebar__logo-icon {
  color: #d6b45e;
}

.admin-sidebar__nav {
  padding: 15px 10px;
}

.admin-sidebar__link {
  min-height: 42px;
  border-left: 0;
  border-radius: 11px;
  color: #c7d4e1;
  font-weight: 650;
}
.admin-sidebar__link:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.09);
}
.admin-sidebar__link--active {
  color: #fff;
  background: rgba(8, 22, 42, 0.38);
  border-left-color: transparent;
  box-shadow: inset 2px 2px 5px rgba(4, 14, 30, 0.36), inset -1px -1px 3px rgba(100, 130, 164, 0.1);
}
.admin-sidebar__link--active .admin-sidebar__link-icon {
  color: #d6b45e;
}

.admin-sidebar__avatar {
  background: linear-gradient(135deg, #d6b45e, #a9771e);
  box-shadow: 2px 2px 5px rgba(5, 17, 34, 0.35);
}

.admin-sidebar__user {
  border-radius: 11px;
}
.admin-sidebar__user:hover {
  background: rgba(255, 255, 255, 0.06) !important;
}

.admin-sidebar__logout {
  border-radius: 10px;
}
.admin-sidebar__logout:hover {
  background: rgba(198, 91, 91, 0.18);
}

@media (max-width: 1024px) {
  .admin-sidebar--open {
    box-shadow: 12px 0 30px rgba(25, 45, 72, 0.32);
  }
}
@media (max-width: 768px) {
  .admin-content {
    padding: 18px 16px 28px;
  }
}
.admin-layout {
  background: radial-gradient(circle at 100% 0, rgba(201, 168, 76, 0.1), transparent 28rem), #f5f6f8;
  color: #17233a;
}

.admin-main {
  background: transparent;
}

.admin-topbar {
  backdrop-filter: blur(14px);
  background: rgba(255, 255, 255, 0.88);
  border-bottom: 1px solid rgba(23, 35, 58, 0.07);
  box-shadow: none;
  height: 68px;
  padding: 0 clamp(20px, 3vw, 42px);
}

.admin-topbar__page-title {
  color: #17233a;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.admin-topbar__menu-btn, .admin-topbar__icon-btn {
  background: #f7f8fa;
  box-shadow: none;
  color: #44526a;
  transition: background 0.24s cubic-bezier(0.22, 0.8, 0.25, 1), color 0.24s cubic-bezier(0.22, 0.8, 0.25, 1), transform 0.24s cubic-bezier(0.22, 0.8, 0.25, 1);
}
.admin-topbar__menu-btn:hover, .admin-topbar__icon-btn:hover {
  background: #e9edf2;
  color: #17233a;
  transform: translateY(-1px);
}

.admin-content {
  padding: clamp(22px, 3vw, 42px);
}

.admin-sidebar {
  background: #111d31;
  box-shadow: 14px 0 34px rgba(15, 28, 50, 0.12);
}

.admin-sidebar__logo {
  height: 68px;
  padding: 0 18px;
}

.admin-sidebar__logo-icon {
  color: #C9A84C;
}

.admin-sidebar__logo-text {
  font-size: 16px;
  letter-spacing: -0.03em;
}

.admin-sidebar__nav {
  padding: 20px 12px;
}

.admin-sidebar__link {
  border-radius: 9px;
  color: #aebacc;
  margin-bottom: 3px;
  min-height: 44px;
  transition: background 0.24s cubic-bezier(0.22, 0.8, 0.25, 1), color 0.24s cubic-bezier(0.22, 0.8, 0.25, 1), transform 0.24s cubic-bezier(0.22, 0.8, 0.25, 1);
}
.admin-sidebar__link:hover {
  background: rgba(255, 255, 255, 0.07);
  color: #fff;
  transform: translateX(2px);
}
.admin-sidebar__link--active {
  background: rgba(201, 168, 76, 0.14);
  box-shadow: inset 2px 0 0 #C9A84C;
  color: #fff;
}
.admin-sidebar__link--active .admin-sidebar__link-icon {
  color: #C9A84C;
}

.admin-sidebar__footer {
  padding: 14px 12px;
}

.admin-sidebar__user {
  background: rgba(255, 255, 255, 0.045);
}

.admin-sidebar__avatar {
  background: linear-gradient(145deg, #d8b85b, #a97c28);
  box-shadow: none;
}

.admin-sidebar__logo {
  height: 82px;
  padding: 0 20px;
  gap: 11px;
}

.admin-sidebar__logo-icon {
  color: #ddb34f;
}

.admin-sidebar__brand {
  display: flex;
  flex: 1 1;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
}

.admin-sidebar__logo-text {
  display: inline-flex;
  color: inherit;
  font-size: 1.85rem;
  font-weight: 800;
  line-height: 0.95;
  letter-spacing: -0.075em;
}

.admin-sidebar__logo-text-primary {
  color: #f4f7fb;
}

.admin-sidebar__logo-text-accent {
  color: #ddb34f;
}

.admin-sidebar__brand-subtitle {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 8px;
  color: #aebfd0;
  font-size: 0.61rem;
  font-weight: 800;
  letter-spacing: 0.14em;
  line-height: 1;
  text-transform: uppercase;
  white-space: nowrap;
}

.admin-sidebar__brand-subtitle::before {
  width: 16px;
  height: 2px;
  content: "";
  background: #ddb34f;
  border-radius: 999px;
}

@media (max-width: 768px) {
  .admin-topbar {
    height: 60px;
    padding: 0 16px;
  }
  .admin-content {
    padding: 20px 16px 32px;
  }
}
body.dark-mode .admin-layout {
  background: radial-gradient(circle at 100% 0, rgba(201, 168, 76, 0.09), transparent 28rem), #09111E;
  color: #F1F5F9;
}
body.dark-mode .admin-topbar {
  background: rgba(15, 28, 50, 0.94);
  border-bottom-color: #1E3055;
}
body.dark-mode .admin-topbar__page-title {
  color: #F1F5F9;
}
body.dark-mode .admin-topbar__menu-btn,
body.dark-mode .admin-topbar__icon-btn {
  color: #94A3B8;
  background: #162444;
}
body.dark-mode .admin-topbar__menu-btn:hover,
body.dark-mode .admin-topbar__icon-btn:hover {
  color: #F1F5F9;
  background: #1E2F4D;
}

.admin-sidebar__logo {
  height: 68px;
  padding: 0 18px;
}

.admin-sidebar__logo-text {
  font-size: 1.55rem;
}

.admin-sidebar__brand-subtitle {
  margin-top: 5px;
}

.admin-sidebar__nav {
  flex: 0 0 auto;
  overflow: visible;
  padding: 10px 12px;
}
.admin-sidebar__nav ul {
  gap: 1px;
}

.admin-sidebar__link {
  margin-bottom: 0;
  min-height: 38px;
  padding: 7px 10px;
}

.admin-sidebar__footer {
  margin-top: auto;
  padding: 9px 12px;
}

.admin-sidebar__user {
  padding: 6px 9px;
}

.admin-sidebar__avatar {
  height: 28px;
  width: 28px;
}

.admin-sidebar__logout {
  padding: 6px 9px;
}

@media (max-height: 740px) {
  .admin-sidebar__logo {
    height: 62px;
  }
  .admin-sidebar__logo-text {
    font-size: 1.4rem;
  }
  .admin-sidebar__brand-subtitle {
    font-size: 0.54rem;
    margin-top: 3px;
  }
  .admin-sidebar__nav {
    padding-bottom: 6px;
    padding-top: 6px;
  }
  .admin-sidebar__link {
    min-height: 35px;
    padding-bottom: 5px;
    padding-top: 5px;
  }
  .admin-sidebar__footer {
    padding-bottom: 7px;
    padding-top: 7px;
  }
  .admin-sidebar__user {
    padding-bottom: 4px;
    padding-top: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/layouts/AdminLayout.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAIA;EACE,aAAA;EACA,iBAAA;EACA,mBC+G4B;ADlH9B;;AAOA;EACE,SAAA;EACA,YAAA;EACA,kBCqF4B;EDpF5B,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,2DAAA;AAJF;AAME;EATF;IAS+B,yBAAA;EAF7B;AACF;;AAME;EACE,QAAA;EACA,UAAA;EACA,kBAAA;EACA,8BAAA;AAHJ;AAME;EACE,cAAA;EACA,mBCiE0B;ADrE9B;AAMI;EAJF;IAI+B,0BAAA;EAF/B;AACF;AAIE;EACE,iBAAA;EACA,mCAAA;AAFJ;AAGI;EAAY,2BCmEc;ADnE9B;;AAKA;EACE,YCqD4B;EDpD5B,mBCiE4B;EDhE5B,gCAAA;EACA,yCCiE4B;EDhE5B,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,MAAA;EACA,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;AAFF;AAIE;EAAU,mBAAA;AADZ;AAEE;EAAkB,0BAAA;EAA4B,mBAAA;AAEhD;AAAE;EAfF;IAe+B,aAAA;EAI7B;AACF;;AAFA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAKF;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAKF;;AAFA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;EACA,yCAAA;AAKF;AAHE;EAAU,mBAAA;EAAqB,cAAA;AAOjC;AANE;EAAkB,0BAAA;EAA4B,mBAAA;AAUhD;;AAPA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qDAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAUF;;AANA;EACE,SAAA;EACA,kBAAA;AASF;AAPE;EAJF;IAI8B,aAAA;EAW5B;AACF;AATE;EAAU,aAAA;AAYZ;;AARA;EACE,eAAA;EACA,QAAA;EACA,+BAAA;EACA,YAAA;EACA,0BAAA;AAWF;;AAPA;EACE,YC7C4B;ED8C5B,iBAAA;EACA,mBC3C4B;ED4C5B,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,kDAAA;EACA,gBAAA;AAUF;AARE;EAfF;IAgBI,4BAAA;IACA,uBAAA;EAWF;EAVE;IAAU,wBAAA;IAA0B,yCAAA;EActC;AACF;;AAVA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,YCtE4B;EDuE5B,gCAAA;EACA,cAAA;AAaF;;AAVA;EAA4B,cAAA;EAAgB,cAAA;AAe5C;;AAbA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAgBF;;AAZA;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,wBAAA;AAeF;AAbE;EAAuB,aAAA;AAgBzB;AAdE;EAAK,gBAAA;EAAkB,aAAA;EAAe,sBAAA;EAAwB,QAAA;AAoBhE;;AAjBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,cCtG4B;EDuG5B,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kCAAA;EACA,6DAAA;AAoBF;AAlBE;EACE,qCAAA;EACA,cC/G0B;ADmI9B;AAjBE;EACE,mCCjH0B;EDkH1B,cCnH0B;EDoH1B,0BClH0B;ADqI9B;AAjBI;EAA4B,cClHF;ADsI9B;AAjBE;EAAkB,0BAAA;EAA4B,mBAAA;AAqBhD;;AAjBA;EAA4B,cAAA;EAAgB,cC1Hd;ADgJ9B;;AArBA;EAA6B,SAAA;AAyB7B;;AAtBA;EACE,6BAAA;EACA,kBAAA;AAyBF;;AArBA;EACE,6BAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAwBF;;AArBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;AAwBF;;AArBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qDAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAwBF;;AApBA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAuBF;;AApBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAuBF;;AApBA;EACE,eAAA;EACA,cCzL4B;ADgN9B;;AApBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,cCrM4B;EDsM5B,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yCAAA;AAuBF;AArBE;EAAU,mCAAA;EAAkC,cAAA;AAyB9C;AAxBE;EAAkB,0BAAA;EAA4B,mBAAA;AA4BhD;;AAxBA,6EAAA;AACA;EACE,kFAAA;EACA,cAAA;AA2BF;;AAxBA;EACE,mBAAA;EACA,gBAAA;EACA,gDAAA;AA2BF;;AAxBA;EAA4B,cAAA;EAAgB,gBAAA;AA6B5C;;AA5BA;EACE,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,yFAAA;AA+BF;AA7BE;EAAU,cAAA;EAAgB,mBAAA;AAiC5B;;AA9BA;EAAiB,aAAA;AAkCjB;;AAhCA;EACE,6DAAA;EACA,eAAA;EACA,6CAAA;AAmCF;;AAhCA;EAA+C,uCAAA;AAoC/C;;AAnCA;EAA4B,cAAA;AAuC5B;;AAtCA;EAAsB,kBAAA;AA0CtB;;AAzCA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AA4CF;AA1CE;EAAU,WAAA;EAAa,qCAAA;AA8CzB;AA7CE;EACE,WAAA;EACA,iCAAA;EACA,8BAAA;EACA,iGAAA;AA+CJ;AA9CI;EAA4B,cAAA;AAiDhC;;AA7CA;EAAyB,qDAAA;EAAuD,6CAAA;AAkDhF;;AAjDA;EAAuB,mBAAA;AAqDvB;AArD4C;EAAU,gDAAA;AAwDtD;;AAvDA;EAAyB,mBAAA;AA2DzB;AA3D8C;EAAU,mCAAA;AA8DxD;;AA5DA;EACE;IAAuB,8CAAA;EAgEvB;AACF;AA9DA;EACE;IAAiB,uBAAA;EAiEjB;AACF;AA7DA;EACE,kGAAA;EACA,cAAA;AA+DF;;AA5DA;EAAc,uBAAA;AAgEd;;AA9DA;EACE,2BAAA;EACA,qCAAA;EACA,+CAAA;EACA,gBAAA;EACA,YAAA;EACA,iCAAA;AAiEF;;AA9DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAiEF;;AA9DA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,6JAAA;AAiEF;AA/DE;EAAU,mBAAA;EAAqB,cAAA;EAAgB,2BAAA;AAoEjD;;AAjEA;EAAiB,+BAAA;AAqEjB;;AAnEA;EACE,mBAAA;EACA,8CAAA;AAsEF;;AAnEA;EAAuB,YAAA;EAAc,eAAA;AAwErC;;AAvEA;EAA4B,cCzZR;ADoepB;;AA1EA;EAA4B,eAAA;EAAiB,uBAAA;AA+E7C;;AA9EA;EAAsB,kBAAA;AAkFtB;;AAhFA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,6JAAA;AAmFF;AAjFE;EAAU,qCAAA;EAAmC,WAAA;EAAa,0BAAA;AAsF5D;AArFE;EAAY,oCAAA;EAAkC,iCAAA;EAAuC,WAAA;AA0FvF;AAzFE;EAAsC,cCtapB;ADkgBpB;;AAzFA;EAAyB,kBAAA;AA6FzB;;AA5FA;EAAuB,sCAAA;AAgGvB;;AA/FA;EAAyB,qDAAA;EAAuD,gBAAA;AAoGhF;;AAjGA;EACE,YAAA;EACA,eAAA;EACA,SAAA;AAoGF;;AAjGA;EAA4B,cAAA;AAqG5B;;AAnGA;EACE,aAAA;EACA,SAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;AAsGF;;AAnGA;EACE,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AAsGF;;AAnGA;EAAoC,cAAA;AAuGpC;;AAtGA;EAAmC,cAAA;AA0GnC;;AAxGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;AA2GF;;AAxGA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,oBAAA;AA2GF;;AAxGA;EACE;IAAgB,YAAA;IAAc,eAAA;EA6G9B;EA5GA;IAAiB,uBAAA;EA+GjB;AACF;AA3GE;EACE,mGAAA;EACA,cCxckB;ADqjBtB;AA1GE;EACE,kCAAA;EACA,4BC3ckB;ADujBtB;AAzGE;EAA4B,cChdR;AD4jBtB;AA1GE;;EAEE,cCndkB;EDodlB,mBCvdkB;ADmkBtB;AA1GI;;EAAU,cCvdQ;EDudW,mBCxdX;ADukBtB;;AAzGA;EACE,YAAA;EACA,eAAA;AA4GF;;AAzGA;EAA4B,kBAAA;AA6G5B;;AA5GA;EAAiC,eAAA;AAgHjC;;AA9GA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AAiHF;AA/GE;EAAK,QAAA;AAkHP;;AA/GA;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;AAkHF;;AA/GA;EACE,gBAAA;EACA,iBAAA;AAkHF;;AA/GA;EAAuB,gBAAA;AAmHvB;;AAlHA;EAAyB,YAAA;EAAc,WAAA;AAuHvC;;AAtHA;EAAyB,gBAAA;AA0HzB;;AAxHA;EACE;IAAuB,YAAA;EA4HvB;EA3HA;IAA4B,iBAAA;EA8H5B;EA7HA;IAAiC,kBAAA;IAAmB,eAAA;EAiIpD;EAhIA;IAAsB,mBAAA;IAAqB,gBAAA;EAoI3C;EAnIA;IAAuB,gBAAA;IAAkB,mBAAA;IAAqB,gBAAA;EAwI9D;EAvIA;IAAyB,mBAAA;IAAqB,gBAAA;EA2I9C;EA1IA;IAAuB,mBAAA;IAAqB,gBAAA;EA8I5C;AACF","sourcesContent":["@import '../styles/variables';\n@import '../styles/mixins';\n\n// ── Layout shell ──────────────────────────────────────────────────────────────\n.admin-layout {\n  display: flex;\n  min-height: 100vh;\n  background: $admin-content-bg;\n}\n\n// ── Main area ─────────────────────────────────────────────────────────────────\n.admin-main {\n  flex: 1;\n  min-width: 0; // Allow wide page content to scroll within its own container.\n  margin-left: $admin-sidebar-width;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  transition: margin-left 0.22s ease, margin-right 0.22s ease;\n\n  @media (max-width: 1024px) { margin-left: 0 !important; }\n}\n\n// ── RTL overrides ─────────────────────────────────────────────────────────────\nhtml[dir=\"rtl\"] {\n  .admin-sidebar {\n    right: 0;\n    left: auto;\n    border-right: none;\n    border-left: 1px solid $admin-sidebar-border;\n  }\n\n  .admin-main {\n    margin-left: 0;\n    margin-right: $admin-sidebar-width;\n\n    @media (max-width: 1024px) { margin-right: 0 !important; }\n  }\n\n  .admin-sidebar__link {\n    border-left: none;\n    border-right: 3px solid transparent;\n    &--active { border-right-color: $admin-sidebar-active-border; }\n  }\n}\n\n// ── Topbar ────────────────────────────────────────────────────────────────────\n.admin-topbar {\n  height: $admin-topbar-height;\n  background: $admin-topbar-bg;\n  border-bottom: 1px solid $admin-topbar-border;\n  box-shadow: $admin-topbar-shadow;\n  display: flex;\n  align-items: center;\n  padding: 0 24px;\n  gap: 16px;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.admin-topbar__menu-btn {\n  display: none;\n  background: transparent;\n  border: none;\n  color: #374151;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s;\n\n  &:hover { background: #F3F4F6; }\n  &:focus-visible { outline: 2px solid #2563EB; outline-offset: 2px; }\n\n  @media (max-width: 1024px) { display: flex; }\n}\n\n.admin-topbar__page-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #111827;\n  flex: 1;\n}\n\n.admin-topbar__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.admin-topbar__icon-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #F3F4F6;\n  border: none;\n  color: #374151;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background 0.15s, color 0.15s;\n\n  &:hover { background: #E5E7EB; color: #111827; }\n  &:focus-visible { outline: 2px solid #2563EB; outline-offset: 2px; }\n}\n\n.admin-topbar__avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #1D4ED8, #2563EB);\n  color: #FFFFFF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: default;\n}\n\n// ── Content area ──────────────────────────────────────────────────────────────\n.admin-content {\n  flex: 1;\n  padding: 28px 28px;\n\n  @media (max-width: 768px) { padding: 16px; }\n\n  // Skip-to-main focus ring\n  &:focus { outline: none; }\n}\n\n// ── Overlay (mobile) ─────────────────────────────────────────────────────────\n.admin-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  z-index: 199;\n  backdrop-filter: blur(2px);\n}\n\n// ── Sidebar ───────────────────────────────────────────────────────────────────\n.admin-sidebar {\n  width: $admin-sidebar-width;\n  min-height: 100vh;\n  background: $admin-sidebar-bg;\n  border-right: 1px solid $admin-sidebar-border;\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 200;\n  transition: width 0.22s ease, transform 0.22s ease;\n  overflow: hidden;\n\n  @media (max-width: 1024px) {\n    transform: translateX(-100%);\n    width: $admin-sidebar-width !important;\n    &--open { transform: translateX(0); box-shadow: 4px 0 32px rgba(0,0,0,0.4); }\n  }\n}\n\n// Logo row\n.admin-sidebar__logo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 16px;\n  height: $admin-topbar-height;\n  border-bottom: 1px solid $admin-sidebar-border;\n  flex-shrink: 0;\n}\n\n.admin-sidebar__logo-icon { color: #2563EB; flex-shrink: 0; }\n\n.admin-sidebar__logo-text {\n  font-size: 15px;\n  font-weight: 700;\n  color: #FFFFFF;\n  letter-spacing: -0.02em;\n  white-space: nowrap;\n  flex: 1;\n}\n\n// Nav\n.admin-sidebar__nav {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 12px 8px;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n\n  &::-webkit-scrollbar { display: none; }\n\n  ul { list-style: none; display: flex; flex-direction: column; gap: 2px; }\n}\n\n.admin-sidebar__link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 10px;\n  border-radius: 8px;\n  color: $admin-sidebar-text;\n  font-size: 13.5px;\n  font-weight: 500;\n  text-decoration: none;\n  white-space: nowrap;\n  border-left: 2px solid transparent;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n\n  &:hover {\n    background: rgba(255,255,255,0.06);\n    color: $admin-sidebar-text-hover;\n  }\n\n  &--active {\n    background: $admin-sidebar-active-bg;\n    color: $admin-sidebar-active;\n    border-left-color: $admin-sidebar-active-border;\n\n    .admin-sidebar__link-icon { color: $admin-sidebar-icon-active; }\n  }\n\n  &:focus-visible { outline: 2px solid #2563EB; outline-offset: 2px; }\n\n}\n\n.admin-sidebar__link-icon { flex-shrink: 0; color: $admin-sidebar-icon; }\n.admin-sidebar__link-label { flex: 1; }\n\n// Go to Home\n.admin-sidebar__home {\n  border-top: 1px solid $admin-sidebar-border;\n  padding: 8px 8px 0;\n}\n\n// Footer\n.admin-sidebar__footer {\n  border-top: 1px solid $admin-sidebar-border;\n  padding: 12px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.admin-sidebar__user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 8px;\n}\n\n.admin-sidebar__avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #1D4ED8, #2563EB);\n  color: #FFFFFF;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  // WCAG: decorative, has aria-hidden\n}\n\n.admin-sidebar__user-info {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.admin-sidebar__user-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #FFFFFF;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.admin-sidebar__user-role {\n  font-size: 11px;\n  color: $admin-sidebar-text;\n}\n\n.admin-sidebar__logout {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 10px;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  color: $admin-sidebar-text;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n\n  &:hover { background: rgba(239,68,68,0.12); color: #FCA5A5; }\n  &:focus-visible { outline: 2px solid #EF4444; outline-offset: 2px; }\n\n}\n\n/* Admin portal neumorphism: shared raised navigation and content surfaces. */\n.admin-layout {\n  background: radial-gradient(circle at 88% 0%, #f9fcff 0, transparent 31%), #e9eff6;\n  color: #2c435d;\n}\n\n.admin-topbar {\n  background: #edf3f8;\n  border-bottom: 0;\n  box-shadow: 0 7px 20px rgba(145, 163, 184, .16);\n}\n\n.admin-topbar__page-title { color: #1c3456; font-weight: 750; }\n.admin-topbar__menu-btn, .admin-topbar__icon-btn {\n  color: #39516d;\n  background: #edf3f8;\n  border-radius: 10px;\n  box-shadow: 4px 4px 9px rgba(145, 163, 184, .2), -3px -3px 7px rgba(255, 255, 255, .82);\n\n  &:hover { color: #1c3456; background: #f4f8fb; }\n}\n\n.admin-content { padding: 28px; }\n\n.admin-sidebar {\n  background: linear-gradient(160deg, #1f385b 0%, #172944 100%);\n  border-right: 0;\n  box-shadow: 8px 0 22px rgba(43, 67, 93, .18);\n}\n\n.admin-sidebar__logo, .admin-sidebar__footer { border-color: rgba(201, 216, 232, .14); }\n.admin-sidebar__logo-icon { color: #d6b45e; }\n.admin-sidebar__nav { padding: 15px 10px; }\n.admin-sidebar__link {\n  min-height: 42px;\n  border-left: 0;\n  border-radius: 11px;\n  color: #c7d4e1;\n  font-weight: 650;\n\n  &:hover { color: #fff; background: rgba(255, 255, 255, .09); }\n  &--active {\n    color: #fff;\n    background: rgba(8, 22, 42, .38);\n    border-left-color: transparent;\n    box-shadow: inset 2px 2px 5px rgba(4, 14, 30, .36), inset -1px -1px 3px rgba(100, 130, 164, .1);\n    .admin-sidebar__link-icon { color: #d6b45e; }\n  }\n}\n\n.admin-sidebar__avatar { background: linear-gradient(135deg, #d6b45e, #a9771e); box-shadow: 2px 2px 5px rgba(5, 17, 34, .35); }\n.admin-sidebar__user { border-radius: 11px; &:hover { background: rgba(255, 255, 255, .06) !important; } }\n.admin-sidebar__logout { border-radius: 10px; &:hover { background: rgba(198, 91, 91, .18); } }\n\n@media (max-width: 1024px) {\n  .admin-sidebar--open { box-shadow: 12px 0 30px rgba(25, 45, 72, .32); }\n}\n\n@media (max-width: 768px) {\n  .admin-content { padding: 18px 16px 28px; }\n}\n\n// ── Admin command centre visual layer ───────────────────────────────────────\n// Presentation only: all navigation and protected-route behaviour remains in JSX.\n.admin-layout {\n  background: radial-gradient(circle at 100% 0, rgba(201, 168, 76, .10), transparent 28rem), #f5f6f8;\n  color: #17233a;\n}\n\n.admin-main { background: transparent; }\n\n.admin-topbar {\n  backdrop-filter: blur(14px);\n  background: rgba(255, 255, 255, .88);\n  border-bottom: 1px solid rgba(23, 35, 58, .07);\n  box-shadow: none;\n  height: 68px;\n  padding: 0 clamp(20px, 3vw, 42px);\n}\n\n.admin-topbar__page-title {\n  color: #17233a;\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: -.01em;\n}\n\n.admin-topbar__menu-btn, .admin-topbar__icon-btn {\n  background: #f7f8fa;\n  box-shadow: none;\n  color: #44526a;\n  transition: background .24s cubic-bezier(.22,.8,.25,1), color .24s cubic-bezier(.22,.8,.25,1), transform .24s cubic-bezier(.22,.8,.25,1);\n\n  &:hover { background: #e9edf2; color: #17233a; transform: translateY(-1px); }\n}\n\n.admin-content { padding: clamp(22px, 3vw, 42px); }\n\n.admin-sidebar {\n  background: #111d31;\n  box-shadow: 14px 0 34px rgba(15, 28, 50, .12);\n}\n\n.admin-sidebar__logo { height: 68px; padding: 0 18px; }\n.admin-sidebar__logo-icon { color: $gold-color; }\n.admin-sidebar__logo-text { font-size: 16px; letter-spacing: -.03em; }\n.admin-sidebar__nav { padding: 20px 12px; }\n\n.admin-sidebar__link {\n  border-radius: 9px;\n  color: #aebacc;\n  margin-bottom: 3px;\n  min-height: 44px;\n  transition: background .24s cubic-bezier(.22,.8,.25,1), color .24s cubic-bezier(.22,.8,.25,1), transform .24s cubic-bezier(.22,.8,.25,1);\n\n  &:hover { background: rgba(255,255,255,.07); color: #fff; transform: translateX(2px); }\n  &--active { background: rgba(201,168,76,.14); box-shadow: inset 2px 0 0 $gold-color; color: #fff; }\n  &--active .admin-sidebar__link-icon { color: $gold-color; }\n}\n\n.admin-sidebar__footer { padding: 14px 12px; }\n.admin-sidebar__user { background: rgba(255,255,255,.045); }\n.admin-sidebar__avatar { background: linear-gradient(145deg, #d8b85b, #a97c28); box-shadow: none; }\n\n// Shared Yet2Book portal brand lockup.\n.admin-sidebar__logo {\n  height: 82px;\n  padding: 0 20px;\n  gap: 11px;\n}\n\n.admin-sidebar__logo-icon { color: #ddb34f; }\n\n.admin-sidebar__brand {\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.admin-sidebar__logo-text {\n  display: inline-flex;\n  color: inherit;\n  font-size: 1.85rem;\n  font-weight: 800;\n  line-height: .95;\n  letter-spacing: -.075em;\n}\n\n.admin-sidebar__logo-text-primary { color: #f4f7fb; }\n.admin-sidebar__logo-text-accent { color: #ddb34f; }\n\n.admin-sidebar__brand-subtitle {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin-top: 8px;\n  color: #aebfd0;\n  font-size: .61rem;\n  font-weight: 800;\n  letter-spacing: .14em;\n  line-height: 1;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.admin-sidebar__brand-subtitle::before {\n  width: 16px;\n  height: 2px;\n  content: '';\n  background: #ddb34f;\n  border-radius: 999px;\n}\n\n@media (max-width: 768px) {\n  .admin-topbar { height: 60px; padding: 0 16px; }\n  .admin-content { padding: 20px 16px 32px; }\n}\n\n// Portal-level dark surfaces keep the global setting readable on every admin route.\nbody.dark-mode {\n  .admin-layout {\n    background: radial-gradient(circle at 100% 0, rgba(201, 168, 76, .09), transparent 28rem), $dark-bg;\n    color: $dark-text;\n  }\n\n  .admin-topbar {\n    background: rgba(15, 28, 50, .94);\n    border-bottom-color: $dark-border;\n  }\n\n  .admin-topbar__page-title { color: $dark-text; }\n\n  .admin-topbar__menu-btn,\n  .admin-topbar__icon-btn {\n    color: $dark-text-secondary;\n    background: $dark-surface-2;\n\n    &:hover { color: $dark-text; background: $dark-surface-hover; }\n  }\n}\n\n// Keep the complete admin navigation visible as one fixed portal rail instead\n// of turning it into a second independently scrolling surface.\n.admin-sidebar__logo {\n  height: 68px;\n  padding: 0 18px;\n}\n\n.admin-sidebar__logo-text { font-size: 1.55rem; }\n.admin-sidebar__brand-subtitle { margin-top: 5px; }\n\n.admin-sidebar__nav {\n  flex: 0 0 auto;\n  overflow: visible;\n  padding: 10px 12px;\n\n  ul { gap: 1px; }\n}\n\n.admin-sidebar__link {\n  margin-bottom: 0;\n  min-height: 38px;\n  padding: 7px 10px;\n}\n\n.admin-sidebar__footer {\n  margin-top: auto;\n  padding: 9px 12px;\n}\n\n.admin-sidebar__user { padding: 6px 9px; }\n.admin-sidebar__avatar { height: 28px; width: 28px; }\n.admin-sidebar__logout { padding: 6px 9px; }\n\n@media (max-height: 740px) {\n  .admin-sidebar__logo { height: 62px; }\n  .admin-sidebar__logo-text { font-size: 1.4rem; }\n  .admin-sidebar__brand-subtitle { font-size: .54rem; margin-top: 3px; }\n  .admin-sidebar__nav { padding-bottom: 6px; padding-top: 6px; }\n  .admin-sidebar__link { min-height: 35px; padding-bottom: 5px; padding-top: 5px; }\n  .admin-sidebar__footer { padding-bottom: 7px; padding-top: 7px; }\n  .admin-sidebar__user { padding-bottom: 4px; padding-top: 4px; }\n}\n","﻿// --- Yet2Book Design System --- Royal Navy x Warm Gold -----------------------\n\n// -- Brand Palette -------------------------------------------------------------\n$primary-color:     #1B2B4B;\n$primary-hover:     #0F1C32;\n$primary-light:     #EEF2F8;\n$primary-border:    #C4CDD8;\n\n$gold-color:        #C9A84C;\n$gold-hover:        #B8953D;\n$gold-light:        #FDF8EE;\n$gold-border:       #E8D5A3;\n\n$secondary-color:   #0F1C32;\n$accent-color:      #EEF2F8;\n\n// -- Surfaces ------------------------------------------------------------------\n$background-light:  #F7F8FA;\n$surface-white:     #FFFFFF;\n$surface-off:       #FAFBFD;\n\n// -- Typography ----------------------------------------------------------------\n$text-color:        #0F1C32;\n$text-gray:         #64748B;\n$text-muted:        #94A3B8;\n\n// -- Borders -------------------------------------------------------------------\n$border-color:      #E2E8F0;\n$border-strong:     #CBD5E1;\n\n// -- Semantic ------------------------------------------------------------------\n$error-color:       #DC2626;\n$success-color:     #16A34A;\n$warning-color:     #D97706;\n$info-color:        #2563EB;\n\n// -- Dark Mode -----------------------------------------------------------------\n$dark-bg:             #09111E;\n$dark-surface:        #0F1C32;\n$dark-surface-2:      #162444;\n$dark-surface-hover:  #1E2F4D;\n$dark-text:           #F1F5F9;\n$dark-text-secondary: #94A3B8;\n$dark-border:         #1E3055;\n$dark-input-bg:       #0B1527;\n$dark-input-border:   #263A5E;\n$dark-shadow:         rgba(0, 0, 0, 0.8);\n\n// -- Spacing -------------------------------------------------------------------\n$spacing-xs:  4px;\n$spacing-sm:  8px;\n$spacing-md:  16px;\n$spacing-lg:  24px;\n$spacing-xl:  40px;\n$spacing-xxl: 64px;\n\n// -- Layout --------------------------------------------------------------------\n$border-radius:    10px;\n$border-radius-lg: 16px;\n$border-radius-xl: 24px;\n$transition:       0.18s ease;\n$theme-transition: all 0.25s ease;\n\n// -- Shadows -------------------------------------------------------------------\n$shadow-xs:      0 1px 3px rgba(0, 0, 0, 0.06);\n$shadow-sm:      0 2px 8px rgba(0, 0, 0, 0.07);\n$shadow-md:      0 4px 20px rgba(0, 0, 0, 0.09);\n$shadow-lg:      0 8px 40px rgba(0, 0, 0, 0.12);\n$shadow-xl:      0 16px 64px rgba(0, 0, 0, 0.16);\n$shadow-focus:   0 0 0 3px rgba(201, 168, 76, 0.28);\n$shadow-dark-md: 0 4px 24px rgba(0, 0, 0, 0.6);\n$shadow-gold:    0 4px 20px rgba(201, 168, 76, 0.35);\n\n// -- Typography ----------------------------------------------------------------\n$font-family:          'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n$font-family-display:  'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n$font-size-xs:         11px;\n$font-size-sm:         13px;\n$font-size-base:       15px;\n$font-size-lg:         16px;\n$font-size-xl:         18px;\n$font-size-xxl:        24px;\n$font-size-xxxl:       32px;\n$font-weight-normal:   400;\n$font-weight-medium:   500;\n$font-weight-semibold: 600;\n$font-weight-bold:     700;\n$font-weight-black:    800;\n\n// -- Legacy Aliases ------------------------------------------------------------\n$light-gray:  $accent-color;\n$text-dark:   $text-color;\n$ocean-blue:  $primary-color;\n$ocean-light: $primary-light;\n$radius-sm:   6px;\n$radius-md:   $border-radius;\n$radius-lg:   $border-radius-lg;\n\n// -- Admin Sidebar -------------------------------------------------------------\n$admin-sidebar-width:         240px;\n$admin-sidebar-collapsed-width: 64px;\n$admin-topbar-height:         60px;\n\n$admin-sidebar-bg:            #0B1527;\n$admin-sidebar-border:        #1A2E4A;\n$admin-sidebar-text:          #94A3B8;\n$admin-sidebar-text-hover:    #CBD5E1;\n$admin-sidebar-active:        #FFFFFF;\n$admin-sidebar-active-bg:     rgba(37, 99, 235, 0.18);\n$admin-sidebar-active-border: #2563EB;\n$admin-sidebar-icon:          #64748B;\n$admin-sidebar-icon-active:   #2563EB;\n$admin-sidebar-badge:         #EF4444;\n\n$admin-topbar-bg:             #FFFFFF;\n$admin-topbar-border:         #E2E8F0;\n$admin-topbar-shadow:         0 1px 3px rgba(0,0,0,0.08);\n\n$admin-content-bg:            #F1F5F9;\n$admin-card-bg:               #FFFFFF;\n$admin-card-shadow:           0 1px 4px rgba(0,0,0,0.06);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
